import validator from "validator";
import message from "../../../../messages/campaign/banner/simple";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.NAME_DOSE_NOT_EXIST;
  }

  return true;
};

const validateCategoryID = (categoryID) => {
  if (validator.isEmpty(categoryID)) {
    return message.CATEGORY_ID_NOT_EXIST;
  }

  if (!validator.isNumeric(categoryID)) {
    return message.CATEGORY_ID_INVALID;
  }

  return true;
};

const validateFormAddCampaign = (info) => {
  const resValidateName = validateName(info.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidateCategoryID = validateCategoryID(info.category_id);
  if (resValidateCategoryID != true) {
    return resValidateCategoryID;
  }

  return true;
};

export default validateFormAddCampaign;
